import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { fromInt2ii0rejb1w62w as fromInt } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import {
  awaitContent$default2jefvu0cvwa0w as awaitContent$default,
  ByteReadChannel2wzou76jce72d as ByteReadChannel,
} from './ByteReadChannel.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { IOException1wyutdmfe71nu as IOException } from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/-PlatformJs.mjs';
import { CloseToken4utf44psnuyc as CloseToken } from './CloseToken.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SourceByteReadChannelClass;
function SourceByteReadChannel() {
  if (SourceByteReadChannelClass === VOID) {
    class $ {
      constructor(source) {
        this.a4m_1 = source;
        this.b4m_1 = null;
      }
      v4j() {
        var tmp0_safe_receiver = this.b4m_1;
        return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.w4j();
      }
      x4j() {
        return this.a4m_1.p3y();
      }
      q4j() {
        var tmp0_safe_receiver = this.v4j();
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          throw tmp0_safe_receiver;
        }
        return this.a4m_1.o3y();
      }
      *y4j(min, $completion) {
        var tmp0_safe_receiver = this.v4j();
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          throw tmp0_safe_receiver;
        }
        return this.a4m_1.v3y(fromInt(min));
      }
      i4k(cause) {
        if (!(this.b4m_1 == null))
          return Unit_instance;
        this.a4m_1.l6();
        var tmp = this;
        var tmp1_elvis_lhs = cause == null ? null : cause.message;
        tmp.b4m_1 = new (CloseToken())(IOException().j4i(tmp1_elvis_lhs == null ? 'Channel was cancelled' : tmp1_elvis_lhs, cause));
      }
    }
    protoOf($).e4k = awaitContent$default;
    initMetadataForClass($, 'SourceByteReadChannel', VOID, VOID, [ByteReadChannel()], [1]);
    SourceByteReadChannelClass = $;
  }
  return SourceByteReadChannelClass;
}
//region block: exports
export {
  SourceByteReadChannel as SourceByteReadChannel1ruj5s0fyiukm,
};
//endregion

//# sourceMappingURL=SourceByteReadChannel.mjs.map
